import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Select } from "antd";
import { numberWithCommas } from "../../../utils";

function TotalProduction() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/dashboard/getAllDashboardData";
  const { loading, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
  }));

  const maxValue = data?.productionPerScheme?.length
    ? Math.max(...data.productionPerScheme.map((d) => d?.value))
    : 0;
  const [countyId, setCountyId] = useState(null);
  const dispatch = useDispatch();

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white  w-full h-full">
      <div className="flex items-center justify-between">
        <span className="text-[#424242] font-interSans text-[.75rem] font-[500]">
          Total Production Value Per Scheme (Kes)
        </span>
      </div>

      {!data?.productionPerScheme?.length ? (
        <div className="flex items-center justify-center h-full">
          <span className="text-[#888] text-[.75rem]">
            No production data available yet
          </span>
        </div>
      ) : (
        <div className="flex flex-col gap-4 mt-4">
          {data.productionPerScheme.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div className="w-[5rem] truncate text-sm text-gray-700">
                {item?.name}
              </div>
              <div className="flex-1 bg-gray-200 h-2 rounded-full relative">
                <div
                  className="h-2 rounded-full"
                  style={{
                    width: `${(item?.value / maxValue) * 100}%`,
                    backgroundColor: item?.color,
                  }}
                ></div>
              </div>
              <div className="min-w-fit px-2 text-right text-sm text-gray-700">
                {numberWithCommas(item?.value)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TotalProduction;
